import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  TransportistaGatewayHttpService,
  TransportistaGatewayPostOptions,
} from '../interceptor/http';

export type TransportistaDespachosResumenBody = {
  desde: string;
  hasta: string;
};

/** POST /api/transportista/despachos/resumen */
@Injectable({ providedIn: 'root' })
export class TransportistaDespachosResumenGatewayApi {
  constructor(private readonly gw: TransportistaGatewayHttpService) {}

  post(
    body: TransportistaDespachosResumenBody,
    options?: TransportistaGatewayPostOptions
  ): Observable<unknown> {
    return this.gw.post<unknown>('/despachos/resumen', body, options);
  }
}
